<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import background from '@/assets/tpi-score-bg.svg';
  import scale from '@/assets/tpi-score-scale.svg';

  import TpiScoreNotches from './cmps/TPIScoreNotchesEXP.svelte';
  import TpiScorePointer from './cmps/TPIScorePointer.svelte';

  const scaleDetailStyles = tv({
    base: 'absolute  left-[4px] top-[2px] origin-center transition-all',
    variants: {
      variant: {
        default: 'scale-75 opacity-0',
        detailed: 'scale-[1.02] opacity-100',
      },
    },
  });

  const gradientColors = [
    {
      color: 'rgba(220, 4, 31, 0.59)',
      stop: 0,
    },
    {
      color: 'rgba(252, 95, 114, 0.59)',
      stop: 50,
    },
    {
      color: 'rgba(237, 128, 3, 0.59)',
      stop: 55,
    },
    {
      color: 'rgba(237, 128, 3, 0.59)',
      stop: 80,
    },
    {
      color: 'rgba(110, 203, 11, 0.59)',
      stop: 90,
    },
    {
      color: 'rgba(110, 203, 11, 0.59)',
      stop: 100,
    },
  ];
</script>

<script lang="ts">
  let { value, modified }: { value: number | undefined; modified: boolean } = $props();

  let scaleVariant: 'default' | 'detailed' = $state('default');
  // let scaleLableVariant: 'default' | 'detailed' = $derived(modified ? 'detailed' : scaleVariant);
  const displayValue = $derived(value ? Math.floor(value) : null);

  function onmouseenter() {
    scaleVariant = 'detailed';
  }

  function onmouseleave() {
    scaleVariant = 'default';
  }
</script>

<div class="relative h-[160px] w-[190px]" role="presentation" {onmouseenter} {onmouseleave}>
  <img
    class={scaleDetailStyles({ variant: scaleVariant })}
    src={scale}
    role="presentation"
    alt="TPI-Scale"
  />
  <img
    class="absolute left-1/2 top-[16px] -translate-x-1/2"
    src={background}
    role="presentation"
    alt="TPI-Scale"
  />
  <div class="absolute left-1/2 top-[28px] -translate-x-1/2" role="presentation">
    <TpiScoreNotches
      width={127}
      notchNum={150}
      notchSize={7.5}
      circleRatio={0.7}
      colors={gradientColors}
    />
  </div>
  <div class="absolute left-1/2 top-[16px] -translate-x-1/2" role="presentation">
    <TpiScorePointer radius={29} width={2} circleRatio={0.7} pointerPosition={value} />
  </div>
  {#if displayValue == null}
    <div class="absolute left-1/2 top-[71px] -translate-x-1/2 text-xl text-c-disabled">--</div>
  {/if}
  {#if displayValue != null}
    <div class="absolute left-1/2 top-[71px] -translate-x-1/2 text-xl font-bold text-c-base">
      {displayValue}
    </div>
  {/if}
  <div class="absolute bottom-0 left-1/2 -translate-x-1/2 text-md font-semibold text-c-light">
    % TPI
  </div>
  {#if modified}
    <div class="absolute bottom-[-11px] left-1/2 -translate-x-1/2 text-[8px] text-c-light">
      (modifiziert)
    </div>
  {/if}
</div>
